export default __webpack_public_path__ + "static/media/3c84959dc76d2591.35d9f5cf53c6fbcf8325ba69c379e4a6.svg";